import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const otherAllowanceSlice = createSlice({
  name: "otherAllowance",

  initialState: {
    otherAllowance: [],
  },
  reducers: {
    setEmployeeOtherAllowance: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.otherAllowance = payload;
    },

    resetEmployeeOtherAllowance: (state: any) => {
      state = [];
    },
  },
});

export const { resetEmployeeOtherAllowance, setEmployeeOtherAllowance } =
  otherAllowanceSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default otherAllowanceSlice.reducer;
